// @flow

import stores from 'stores';
import {
  MESSAGE_DISPLAY_TIME,
  MESSAGE_TYPE,
} from '_common/constants/appConfig';

export default (
  message: string,
  duration: number = MESSAGE_DISPLAY_TIME.API_ERROR,
  subData?: Object = {}
) => {
  return stores.uiStore.showMessage(message, {
    duration,
    type: MESSAGE_TYPE.API_ERROR,
    subData,
  });
};
